/* --- ADJUST DYNAMIC WYSIWYG CONTENT --- */
const dynamicContent = document.querySelector('.content-container .dynamic-page-content, .content-container .styled-content');

if (dynamicContent) {
    // Add class custom-table to all tables without an image
    const dynamicContentTables = [...dynamicContent.querySelectorAll('table')]
        .filter((table) => table.getElementsByTagName('img').length === 0);

    dynamicContentTables.forEach((el) => el.classList.add('custom-table'));

    // Wrap tables with > 2 columns
    [...dynamicContentTables]
        .filter((el) => el.querySelectorAll('tr:first-child > th').length > 2)
        .forEach((el) => {
            const wrapper = document.createElement('div');
            wrapper.classList.add('table-wrapper');
            el.parentElement.insertBefore(wrapper, el);
            wrapper.appendChild(el);
        });
}
